// extracted by mini-css-extract-plugin
module.exports = {"section":"FAQSections-section_77cefbad","detail":"FAQSections-detail_e444da96","container":"FAQSections-container_3fc201ce"};